import Vue from 'vue'
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration, } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";


Sentry.init({
  dsn: "https://be9543ae19234a7ead48aba014673625@o448181.ingest.sentry.io/5429171",
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
    }),
    new Integrations.BrowserTracing(),
  ],
  tracesSampleRate: 1,
  debug: false,
  environment: process.env.NODE_ENV,
  beforeSend(event, hint) {
    if (event.exception) {
      //Sentry.showReportDialog({ eventId: event.event_id });
    }
    return event;
  }
});